module.exports = __webpack_public_path__ + "img/Administradoras.6c7163bd.svg";